import { render, staticRenderFns } from "./LocalSettings.vue?vue&type=template&id=79d6612d"
import script from "@/views/modules/Administration/js/LocalSettings.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Administration/js/LocalSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports